import Cookies from 'js-cookie'
import axios from 'axios'
import * as types from '../mutation-types'
import Bowser from 'bowser'
import moment, { now } from 'moment'

const prefix = window.config.prefix
const url = window.config.url

// functions
const printTime = t => {
  const h = Math.floor(t)
  const m = Math.floor((t - h) * 60)
  const a = (h > 11) ? 'PM' : 'AM'
  const h2 = (h > 12) ? h - 12 : h
  if (m === 0) return h2 + a
  if (m < 10) return h2 + ':0' + m + a
  return h2 + ':' + m + a
}

// namespaced
export const namespaced = true

// state
export const state = {
  msg: null,
  gid: window.config.gid || Cookies.get(`${prefix}gid`) || 0,
  rid: Cookies.get(`${prefix}rid`) || 0,
  rid2: 0, // Backup of rid because it might be cleared after payment/submitting
  tb: Cookies.get(`${prefix}tb`) || '',
  tbdata: null,
  tables: [],
  restaurants: null,
  themes: window.config.themes || null,
  config: null,
  catGrps: null,
  cats: null,
  gemsSetting: [],
  mode: null,
  browserid: null,
  version: null,
  storedVersion: null,
  language: 'en-SG',
  modeSelected: false,
  payWithPayNow: false,
  memberToken: null,
  visitAtTimestamp: null
}

// getters
export const getters = {
  msgConfig: state => state.msg,
  gid: state => state.gid,
  rid: state => state.rid,
  rid2: state => state.rid2,
  tb: state => state.tb,
  tbdata: state => state.tbdata,
  tables: state => state.tables,
  restaurants: state => state.restaurants,
  themes: state => state.themes,
  config: state => state.config,
  catGrps: state => state.catGrps,
  cats: state => state.cats,
  mode: state => state.mode,
  gemsSetting: state => state.gemsSetting,
  browserid: state => state.browserid,
  version: state => state.version,
  storedVersion: state => state.storedVersion,
  language: state => state.language,
  modeSelected: state => state.modeSelected,
  payWithPayNow: state => state.payWithPayNow,
  memberToken: state => state.memberToken,
  visitAtTimestamp: state => state.visitAtTimestamp,
  siteUrl: state => {
    return window.config.url + '/' + state.gid + '/' + state.rid
  },
  iOS: () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  },
  browserInfo: () => {
    const browser = Bowser.getParser(window.navigator.userAgent)
    return browser.getBrowser()
  },
  inIframe: () => {
    try {
      return window.self !== window.top
    } catch (e) {
      return true
    }
  },
  isInApp: () => {
    // Ernest request
    return false
    const ua = navigator.userAgent || navigator.vendor || window.opera
    // facebook browser
    if ((ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1)) return true
    // instagram
    if (ua.indexOf('Instagram') > -1) return true
    // wechat browser
    if ((/micromessenger/i).test(ua)) return true
    // qq browser
    if (ua.indexOf('QQ') > -1) return true
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      // ios webview
      if (!(/safari/i).test(ua)) return true
    } else {
      // android webview
      if ((/wv/i).test(ua)) return true
      if ((ua.indexOf('Android') > -1) && (ua.indexOf('Version') > -1)) return true
    }
    return false
  },
  prefix: () => prefix,
  colors: () => {
    return {
      button0: '#D3D3D3',
      button1: '#258FB1',
      button1a: '#09A795',
      button1b: '#40291F',
      button2: '#CFB03D',
      button3: '#A83E2A',
      mode: '#654F39',
      favor: '#830303',
      notification: '#A83E2A',
      content: 'white',
      primary: '#02A192',
      secondary: '#A83E2A',
      accent: '#CFB03D',
      error: '#FF5252',
      info: '#654F39',
      success: '#09A795',
      warning: '#D5B945'
    }
  },
  posType: state => {
    return state.config ? parseInt(state.config.pos_type) : 0
  },
  tid: state => {
    return state.config ? state.config.theme_id : 1
  },
  theme: state => {
    if (state.config) {
      return state.config.iorder_theme
    }
    if (state.restaurants && state.restaurants[0].iorder_theme) {
      return state.restaurants[0].iorder_theme
    }
    return null
  },
  pictures: state => {
    if (state.config && state.config.pictures) {
      return state.config.pictures
    }
    if (state.restaurants && state.restaurants[0].pictures) {
      return state.restaurants[0].pictures
    }
    return url + '/assets/shared/'
  },
  logo: (state, getters) => {
    if (state.config && state.config.logo) {
      return getters.pictures + state.config.logo
    }
    if (state.restaurants && state.restaurants[0].logo) {
      return state.restaurants[0].pictures + state.restaurants[0].logo
    }
    return null
  },
  logoDark: (state, getters) => {
    if (state.config && state.config.logo_dark) {
      return getters.pictures + state.config.logo_dark
    }
    if (state.restaurants && state.restaurants[0].logo_dark) {
      return state.restaurants[0].pictures + state.restaurants[0].logo_dark
    }
    return state.config && state.config.logo ? getters.pictures + state.config.logo : null
  },
  banner: state => {
    if (state.config && state.config.banner) {
      return state.config.banner
    }
    if (state.restaurants && state.restaurants[0].banner) {
      return state.restaurants[0].banner
    }
    return null
  },
  photo: state => {
    if (state.config && state.config.photo) {
      return state.config.photo
    }
    if (state.restaurants && state.restaurants[0].photo) {
      return state.restaurants[0].photo
    }
    return null
  },
  device: state => {
    return state.config && state.config.device_id ? state.config.device_id : 1
  },
  guestId: state => {
    return state.config && state.config.guest_id ? state.config.guest_id : 0
  },
  guestName: state => {
    return state.config && state.config.guest_name ? state.config.guest_name : 'Guest User'
  },
  timeout: state => {
    if (state.config && state.config.timeout) {
      return state.config.timeout
    }
    if (state.restaurants && state.restaurants[0].timeout) {
      return state.restaurants[0].timeout
    }
    return 300
  },
  withLoyalty: state => {
    return state.config ? parseInt(state.config.membership_type) === 1 : false
  },
  withTableNo: state => {
    return state.config ? parseInt(state.config.enable_table_no) === 1 : false
  },
  withQueueNo: state => {
    return state.config ? parseInt(state.config.enable_queue_no) === 1 : false
  },
  enableZeroPrice: state => {
    return parseInt(state.config.enable_zeroprice) === 1
  },
  displayVouchersTo: state => {
    if (state.config) {
      return {
        'all': parseInt(state.config.vouchers_display_type) === 1,
        'members': parseInt(state.config.vouchers_display_type) === 2
      }
    }
    return {
      'all': false,
      'members': true
    }
  },
  displayVouchers: state => {
    return state.config ? parseInt(state.config.vouchers_display_type) === 1 || parseInt(state.config.vouchers_display_type) === 2 : false
  },
  allowLogin: state => {
    return state.config ? parseInt(state.config.membership_type) === 1 || parseInt(state.config.membership_type) === 2 : true
  },
  allowCheckout: state => {
    if (state.config) {
      return {
        'all': !(parseInt(state.config.membership_type) === 0 && parseInt(state.config.member_only) === 1),
        'guest': parseInt(state.config.member_only) === 0,
        'any': !(parseInt(state.config.membership_type) === 0 && parseInt(state.config.member_only) === 1) || parseInt(state.config.member_only) === 0
      }
    }
    return {
      'all': true,
      'guest': true,
      'any': true
    }
  },
  restaurant: state => {
    if (state.config) {
      return {
        group_id: state.gid,
        mobile_group_id: state.config.mobile_group_id,
        restaurant_id: parseInt(state.rid),
        sales_type: state.config.sales_type,
        restaurant_name: state.config.name,
        restaurant_full_name: state.config.full_name,
        rate_id: state.config.loyalty_rate_id
      }
    }
    return null
  },
  redirectUrl: () => {
    return {
      payBeforeServe: url + '/payment',
      payAfterServe: url + '/payment2'
    }
  },
  noPaymentModes: (state, getters) => {
    const allowedPaymodes = getters.mode.allowedPaymodes
    if (state.config && allowedPaymodes.length > 0) {
      const modes = []
      if (allowedPaymodes.find(a => a === 1)) {
        modes.push({
          code: 'paynow',
          title: 'paynow',
          icon: 'phonelink_ring'
        })
      }
      return modes
    }
    return []
  },
  paymentTypes: () => {
    return {
      cybersource: {
        mode: '2',
        title: 'credit_card',
        icon: 'credit_card',
        prod: window.config.cybersourceProd,
        dev: window.config.cybersourceDev
      },
      stripe: {
        mode: 'Stripe',
        title: 'credit_card',
        icon: 'credit_card', // 'fab fa-cc-stripe'
        prod: window.config.stripeProd,
        dev: window.config.stripeDev
      },
      paypal: {
        mode: 'paypal',
        title: 'paypal',
        icon: 'fab fa-paypal',
        prod: window.config.paypalProd,
        dev: window.config.paypalDev
      },
      c2p: {
        mode: 'c2p',
        title: 'credit_card',
        icon: 'credit_card',
        prod: window.config.c2pProd,
        dev: window.config.c2pDev
      },
      nets: {
        mode: 'nets',
        title: 'NETSPay',
        icon: 'card',
        prod: window.config.netsProd,
        dev: window.config.netsDev
      },
      points: {
        mode: 'points',
        title: 'points',
        icon: 'card'
      },
      credits: {
        mode: 'credits',
        title: 'credits',
        icon: 'card'
      },
      pay_at_counter: {
        mode: 'pay_at_counter',
        title: 'Pay At Counter',
        icon: 'point_of_sale'
      },
      apple_pay: {
        mode: 'apple_pay',
        title: 'Apple Pay',
        icon: 'point_of_sale'
      },
      razer: {
        mode: 'razer',
        title: 'credit_card',
        icon: 'credit_card',
        prod: window.config.razerProd,
        dev: window.config.razerDev
      }
    }
  },
  paymentModes: (state, getters) => {
    const allowedPaymodes = getters.mode.allowedPaymodes
    if (state.config && allowedPaymodes.length > 0) {
      const modes = []
      if (allowedPaymodes.find(a => a === 2)) {
        modes.push({
          code: 'cybersource',
          type: state.config.payment_cybersource_id
        })
      }
      if (allowedPaymodes.find(a => a === 3)) {
        modes.push({
          code: 'stripe',
          type: state.config.payment_stripe_id
        })
      }
      if (allowedPaymodes.find(a => a === 4)) {
        modes.push({
          code: 'paypal',
          type: state.config.payment_paypal_id
        })
      }
      if (allowedPaymodes.find(a => a === 5)) {
        modes.push({
          code: 'c2p',
          type: state.config.payment_c2p_id
        })
      }
      if (allowedPaymodes.find(a => a === 6)) {
        modes.push({
          code: 'nets',
          type: state.config.payment_nets_id
        })
      }

      if (allowedPaymodes.find(a => a === 7)) {
        modes.push({
          code: 'pay_at_counter'
        })
      }

      if (allowedPaymodes.find(a => a === 8)) {
        modes.push({
          code: 'apple_pay'
        })
      }

      if (allowedPaymodes.find(a => a === 9)) {
        modes.push({
          code: 'razer',
          type: state.config.payment_razer_id
        })
      }

      return modes
    }
    return []
  },
  allPaymentModesLength: (state, getters) => {
    return getters.noPaymentModes.length + getters.paymentModes.length
  },
  pointsPayment: state => {
    return state.config && state.config.payment_points_id ? state.config.payment_points_id : null
  },
  pointsPaymentId: state => {
    return state.config && state.config.payment_points_id ? state.config.payment_points_id : null
  },
  creditsPayment: state => {
    return state.config && state.config.payment_credits_id ? state.config.payment_credits_id : null
  },
  epayAccount: state => {
    return state.config && state.config.epay_account_name ? state.config.epay_account_name : 'Aptsys'
  },
  modes: state => {
    if (state.catGrps && state.catGrps.length > 0) {
      const modeGrps = state.catGrps.filter(grp => parseInt(grp.is_dining_mode) === 1 && parseInt(grp.is_hidden) === 0)
      if (modeGrps && modeGrps.length > 0) {
        const modes = []
        modeGrps.forEach((grp, index) => {
          const mode = {
            index: index,
            dineMode: parseInt(grp.dine_mode),
            isDinein: parseInt(grp.dine_mode) === 0,
            isTakeaway: parseInt(grp.dine_mode) === 1,
            isDelivery: parseInt(grp.dine_mode) === 2,
            name: grp.name,
            cats: (!grp.gems_cat_ids || grp.gems_cat_ids === 'all') ? 'all' : JSON.parse(grp.gems_cat_ids),
            hasPresetDiscount: (grp.default_preset_discount && parseInt(grp.default_preset_discount.Type) === 2),
            presetDiscount: (grp.default_preset_discount && parseInt(grp.default_preset_discount.Type) === 2)
              ? {
                discount_id: grp.default_preset_discount.ID,
                discount_name: grp.default_preset_discount.Name,
                discount_amount: grp.default_preset_discount.Amount,
                discount_type: 'Percentage',
                non_discount: ''
              }
              : {
                discount_id: '',
                discount_name: '',
                discount_amount: '',
                discount_type: '',
                non_discount: ''
              },
            paymentMode: parseInt(grp.payment_mode),
            allowedPaymodes: grp.allowed_paymodes ? JSON.parse(grp.allowed_paymodes) : [],
            sortOrder: grp.sort_order ? parseInt(grp.sort_order) : null
          }
          modes.push(mode)
        })
        const sortedModes = modes.sort((a, b) => parseInt(a.sortOrder) - parseInt(b.sortOrder))
        sortedModes.forEach(m => { delete m.sortOrder })
        return sortedModes
      }
    }
    return [{
      index: 0,
      dineMode: 0,
      isDinein: 1,
      isTakeaway: 0,
      isDelivery: 0,
      name: 'Dine In',
      cats: 'all',
      hasPresetDiscount: false,
      presetDiscount: {
        discount_id: '',
        discount_name: '',
        discount_amount: '',
        discount_type: '',
        non_discount: ''
      },
      paymentMode: 0,
      allowedPaymodes: []
    }]
  },
  voucherCats: state => {
    if (state.catGrps && state.catGrps.length > 0) {
      const voucherGrps = state.catGrps.filter(grp => parseInt(grp.for_voucher_use) === 1)
      if (voucherGrps && voucherGrps.length > 0) {
        const vCats = []
        voucherGrps.forEach(grp => {
          const cats = JSON.parse(grp.gems_cat_ids)
          if (cats && cats.length > 0) {
            cats.forEach(c => {
              if (vCats.includes(c) === false) {
                vCats.push(c)
              }
            })
          }
        })
        return vCats
      }
    }
    return null
  },
  noShowCats: state => {
    return state.config && state.config.noshow_cats ? JSON.parse(state.config.noshow_cats) : null
  },
  openingHours: state => {
    if (state.config) {
      const start = parseFloat(state.config.opening_hours_start) || 0
      const end = parseFloat(state.config.opening_hours_end) || 24
      let hours
      if (start === 0 && end === 24) {
        hours = '24 Hours'
      } else {
        hours = printTime(start) + ' - ' + printTime(end)
      }
      return {
        hours: hours,
        start: start,
        end: end
      }
    }
    return null
  },
  takeawayHours: state => {
    if (state.config) {
      const start = parseFloat(state.config.opening_hours_start) || 0
      let end = parseFloat(state.config.opening_hours_end) || 24
      if (end !== 24) end = end - 1
      let hours
      if (start === 0 && end === 24) {
        hours = '24 Hours'
      } else {
        hours = printTime(start) + ' - ' + printTime(end)
      }
      return {
        hours: hours,
        start: start,
        end: end,
        interval: 15,
        interval2: 30,
        limit: 5
      }
    }
    return {}
  },
  catItem: state => {
    return {
      imgSize: state.config ? state.config.view_catitem_imgsize : '72px',
      displayDesc: state.config ? parseInt(state.config.catitem_disp_desc) === 1 : true
    }
  },
  itemDetail: state => {
    return {
      imgSize: state.config ? state.config.view_itemdetail_imgsize : '180px'
    }
  },
  allowSpecialRequest: state => {
    return state.config ? parseInt(state.config.enable_special_request) === 1 : false
  },
  holidays: state => {
    return state.config && state.config.holidays ? state.config.holidays : []
  },
  takeawayConfig: state => {
    if (state.config && state.config.takeawayConfig) {
      const takeawayConfig = state.config.takeawayConfig
      return {
        intervalInMinutes: parseInt(takeawayConfig.intervalInMinutes),
        maxTimeRequired: parseFloat(takeawayConfig.maxTimeRequired),
        availableTimeRange: takeawayConfig.availableTimeRange,
        advancedDays: parseInt(takeawayConfig.advancedDays)
      }
    }
    return {
      intervalInMinutes: 15,
      maxTimeRequired: 30,
      availableTimeRange: '10:00-21:00',
      advancedDays: 4
    }
  },
  deliveryConfig: state => {
    if (state.config && state.config.deliveryConfig) {
      const deliveryConfig = state.config.deliveryConfig
      return {
        minType: parseInt(deliveryConfig.minType),
        minItems: parseInt(deliveryConfig.minItems),
        minPrice: parseFloat(deliveryConfig.minPrice),
        maxPrice: parseFloat(deliveryConfig.maxPrice),
        maxPriceMessage: deliveryConfig.maxPriceMessage,
        deliveryChargeType: parseInt(deliveryConfig.deliveryChargeType),
        maxDeliveryDistance: parseFloat(deliveryConfig.maxDeliveryDistance),
        availableTimeRange: deliveryConfig.availableTimeRange,
        advancedDays: parseInt(deliveryConfig.advancedDays),
        discountData: deliveryConfig.discountData,
        enableCutlery: deliveryConfig.enableCutlery
      }
    }
    return {
      minType: 2,
      minItems: 0,
      minPrice: 10,
      deliveryChargeType: 1,
      maxDeliveryDistance: 10,
      availableTimeRange: '10:00-21:00',
      advancedDays: 4,
      discountData: []
    }
  },
  reservationConfig: state => {
    if (state.config && state.config.reservationConfig) {
      const reservationConfig = state.config.reservationConfig
      return {
        eventId: parseInt(reservationConfig.event_id),
        cashierId: parseInt(reservationConfig.cashier_id),
        enableDeposit: reservationConfig.enable_deposit,
        voucherId: parseInt(reservationConfig.voucher_id),
        voucherPrice: reservationConfig.voucher_price,
        sms_content: reservationConfig.sms_content,
        tnc: reservationConfig.tnc ? reservationConfig.tnc.split('\n') : [],
        intervalInMinutes: parseInt(reservationConfig.intervalInMinutes),
        minBeforeReservation: parseInt(reservationConfig.min_before_reservation),
        maxPaxPerReservation: parseFloat(reservationConfig.max_pax_per_reservation),
        availableTimeRange: reservationConfig.availableTimeRange,
        advancedDays: parseInt(reservationConfig.advancedDays)
      }
    }
    return {
      eventId: 0,
      cashierId: 0,
      enableDeposit: 0,
      voucherId: 0,
      voucherPrice: 0.00,
      sms_content: '',
      tnc: [],
      intervalInMinutes: 60,
      maxPaxPerReservation: 10,
      availableTimeRange: '10:00-21:00',
      advancedDays: 7
    }
  },
  loyaltyGroupId: state => {
    return state.config && state.config.loyaltySetting ? state.config.loyaltySetting.loyaltyGroupID : 0
  },
  enableMemberPoints: state => {
    return state.config ? parseInt(state.config.enable_member_points) === 1 : false
  },
  allowMultiLang: state => {
    return state.config ? parseInt(state.config.multiple_lang) === 1 : false
  },
  isPublishable: state => {
    return state.config ? parseInt(state.config.is_publishable) === 1 : true
  },
  nonPublishableMsg: (state, getters) => {
    if (!getters.isPublishable) {
      let msg = {
        title: state.config.full_name,
        msg: 'This restaurant no longer supports takeaway or delivery mode. Kindly visit the restaurant for a good dining experience. Thank you.'
      }
      if (state.config && state.config.not_publishable_msg) {
        try {
          const jsonMsg = JSON.parse(state.config.not_publishable_msg)
          if (jsonMsg.title || jsonMsg.msg) msg = jsonMsg
        } catch (e) { }
      }
      return msg
    }
    return null
  },
  requireMobileOTP: state => {
    return state.config ? parseInt(state.config.otp_type) === 1 : true
  },
  requireEmailOTP: state => {
    return state.config ? parseInt(state.config.otp_type) === 2 : true
  },
  onMaintenance: state => {
    return state.gemsSetting ? parseInt(state.gemsSetting.enableMobileOrder) === 0 : false
  },
  diningTitleMode: state => {
    return state.config ? state.config.dining_title_mode : 1
  },
  categoryListMode: state => {
    return state.config ? state.config.category_list_mode : 0
  },
  itemListMode: state => {
    return state.config ? parseInt(state.config.item_list_mode) : 0
  },
  hasDeliveryMode: (state, getters) => {
    const deliveryMode = getters.modes.find(m => m.isDelivery)
    return !!deliveryMode
  },
  restaurantContact: state => {
    return state.gemsSetting ? state.gemsSetting.RestaurantContact : null
  },
  restaurantAddress: state => {
    if (state.gemsSetting) {
      const address = []
      state.gemsSetting.Header.split('\n').forEach(h => {
        if (h.indexOf('Tel:') > -1 || h.indexOf('Tel ') > -1 || h.indexOf('GST') > -1 || h.indexOf('www.') > -1) return
        address.push(h)
      })
      return address.filter(item => !!item)
        .join(', ')
    }
    return null
  },
  seo: state => {
    return {
      keywords: state.config && state.config.seo_keywords ? state.config.seo_keywords : 'iorder, singapore, food, drinks, dine in, self collect, takeaway, delivery, order, online, menu, promotion',
      description: state.config && state.config.seo_description ? state.config.seo_description : 'Order your favourite food online. We satisfy your food cravings by offering a wide variety of food. Try it today!'
    }
  },
  socialUrl: state => {
    return {
      facebook: state.config && state.config.facebook_id ? 'https://facebook.com/' + state.config.facebook_id : null,
      instagram: state.config && state.config.instagram_id ? 'https://instagram.com/' + state.config.instagram_id : null,
      telegram: state.config && state.config.telegram_id ? 'https://telegram.me/s/' + state.config.telegram_id : null
    }
  },
  enableReservation: state => {
    return state.config && state.config.reservationConfig ? parseInt(state.config.reservationConfig.enable) === 1 : false
  },
  enableReservationDeposit: state => {
    return state.config && state.config.reservationConfig ? parseInt(state.config.reservationConfig.enableDeposit) === 1 : false
  },
  categoryDisplayStyle: state => {
    return state.config ? state.config.category_display_style : 0
  }
}

const insertStyleTagByIOrderTheme = function (theme) {
  let css = ''

  if (theme.unchecked_color) {
    css += `
.v-radio .v-icon {
  color: ${theme.unchecked_color};
}
.v-input--checkbox .v-icon {
  color: ${theme.unchecked_color};
}
`
  }

  if (!css) {
    return
  }

  let head = document.head || document.getElementsByTagName('head')[0]
  let style = document.createElement('style')

  style.type = 'text/css'
  if (style.styleSheet) {
    // This is required for IE8 and below.
    style.styleSheet.cssText = css
  } else {
    style.appendChild(document.createTextNode(css))
  }

  head.appendChild(style)
}

// mutations
export const mutations = {
  [types.SET_CONFIG_MSG] (state, msg) {
    const msgs = {
      config: 'Failed to fetch config',
      cats: 'Failed to fetch menu categories',
      groups: 'Failed to fetch category groups',
      outlets: 'Failed to fetch group outlets',
      themes: 'Failed to fetch themes',
      table: 'Failed to set table'
    }
    const message = msg ? (msgs[msg] ? msgs[msg] : msg) : 'Failed to fetch config'
    state.msg = message
  },

  [types.RESET_CONFIG_MSG] (state) {
    state.msg = null
  },

  [types.FETCH_CAT_GROUPS] (state, groups) {
    if (groups) {
      state.catGrps = [...groups]
    } else {
      state.catGrps = null
    }
  },

  [types.FETCH_CATS] (state, cats) {
    if (cats) {
      state.cats = [...cats]
    } else {
      state.cats = null
    }
  },

  [types.FETCH_OUTLETS] (state, restaurants) {
    if (restaurants) {
      state.restaurants = [...restaurants]
    } else {
      state.restaurants = null
    }
  },

  [types.FETCH_THEMES] (state, themes) {
    state.themes = [...themes]
  },

  [types.FETCH_CONFIG] (state, config) {
    if (config) {
      state.gemsSetting = config.gemsSetting
      delete config.gemsSetting
      state.config = { ...config }

      if (state.config.hasOwnProperty('iorder_theme') && typeof state.config.iorder_theme === 'object' && state.config.iorder_theme !== null) {
        insertStyleTagByIOrderTheme(state.config.iorder_theme)
      }

      let loyaltyGroupId = state.config && state.config.loyaltySetting ? state.config.loyaltySetting.loyaltyGroupID : 0
      Cookies.set(`${prefix}loyalty_gid`, parseInt(loyaltyGroupId))
    } else {
      state.config = null
    }
  },

  [types.SET_MODE] (state, mode) {
    state.mode = mode
  },

  [types.SET_GID] (state, gid) {
    state.gid = gid
    state.restaurants = null
  },

  [types.SET_RID] (state, rid) {
    state.rid = rid
    if (rid !== 0) state.rid2 = rid
  },

  [types.RESET_RES_DETAILS] (state) {
    state.config = null
    state.cats = null
    state.catGrps = null
    state.mode = 0
    state.modeSelected = false
  },

  [types.SET_TB] (state, tb) {
    state.tb = tb
  },

  [types.SET_BROWSER_ID] (state, bid) {
    state.browserid = bid
  },

  [types.SET_STOREDVERSION] (state, version) {
    state.storedVersion = version
  },

  [types.SET_VERSION] (state, version) {
    state.version = version
  },

  [types.SET_TBDATA] (state, tbdata) {
    state.tbdata = tbdata
  },

  [types.FETCH_TABLES] (state, payload) {
    // payload is tables
    state.tables = payload
  },

  [types.RESET_TABLES] (state) {
    state.tables = []
  },

  [types.RESET_LANGUAGE] (state) {
    state.language = 'en-SG'
  },

  [types.CHANGE_LANGUAGE] (state, payload) {
    state.language = payload
  },

  [types.SET_MODE_SELECTED] (state) {
    state.modeSelected = true
  },

  [types.RESET_MODE_SELECTED] (state) {
    state.modeSelected = false
  },

  [types.SET_MEMBER_TOKEN] (state, payload) {
    state.memberToken = payload
  },

  [types.RESET_MEMBER_TOKEN] (state) {
    state.memberToken = null
  },

  [types.SET_VISIT_AT_TIMESTAMP] (state, payload) {
    state.visitAtTimestamp = payload
  }
}

// actions
export const actions = {
  async fetchCatGroups ({ commit, state }) {
    if (state.rid) {
      commit(types.RESET_CONFIG_MSG)
      try {
        const { data } = await axios.post('/api/restaurant/groups', { restaurant_id: parseInt(state.rid) })
        commit(types.FETCH_CAT_GROUPS, data)
      } catch (e) {
        commit(types.SET_CONFIG_MSG, 'groups')
      }
    }
  },

  async fetchCats ({ commit, state }) {
    if (state.rid) {
      commit(types.RESET_CONFIG_MSG)
      try {
        const { data } = await axios.post('/api/restaurant/cats', { restaurant_id: parseInt(state.rid) })
        commit(types.FETCH_CATS, data)
      } catch (e) {
        commit(types.SET_CONFIG_MSG, 'cats')
      }
    }
  },

  async fetchOutlets ({ commit, state }) {
    console.log('-----fetchOutlets-----')
    console.log(window.config.gid || Cookies.get(`${prefix}gid`) || 0)
    console.log(window.config.gid, Cookies.get(`${prefix}gid`), 0)
    console.log(parseInt(state.gid))
    console.log('-----fetchOutlets-----')

    commit(types.RESET_CONFIG_MSG)
    try {
      const { data } = await axios.post('/api/restaurants', { group_id: parseInt(state.gid) })
      commit(types.FETCH_OUTLETS, data)
    } catch (e) {
      commit(types.SET_CONFIG_MSG, 'outlets')
    }
  },

  async fetchThemes ({ commit }) {
    commit(types.RESET_CONFIG_MSG)
    try {
      const { data } = await axios.post('/api/themes')
      commit(types.FETCH_THEMES, data)
    } catch (e) {
      commit(types.SET_CONFIG_MSG, 'themes')
    }
  },

  async fetchConfig ({ commit, state }) {
    commit(types.RESET_CONFIG_MSG)
    try {
      const { data } = await axios.post('/api/restaurant/config', { restaurant_id: parseInt(state.rid) })
      Cookies.set(`${prefix}visit`, now())
      commit(types.FETCH_CONFIG, data)
    } catch (e) {
      commit(types.SET_CONFIG_MSG, 'config')
    }
  },

  changeMode ({ commit }, payload) {
    // payload is mode
    commit(types.SET_MODE, payload)
  },

  changeGid ({ commit, state }, payload) {
    // payload is gid
    if (parseInt(state.gid) !== parseInt(payload)) {
      Cookies.set(`${prefix}gid`, payload)
      commit(types.SET_GID, payload)
    }
  },

  changeRid ({ commit }, payload) {
    // payload is rid
    // Setting cookies outside to refresh expiry time regardless of the payload
    Cookies.set(`${prefix}rid`, payload, {
      expires: parseInt(window.config.activeMinutes) / 60 / 24
    })
    Cookies.set(`${prefix}visit`, now())
    commit(types.SET_RID, payload)
  },

  resetResDetails ({ commit }) {
    commit(types.RESET_RES_DETAILS)
    commit(types.RESET_MODE_SELECTED)
  },

  changeTb ({ commit, state }, payload) {
    // payload is tb (qr code)
    if (!state.tbdata || (state.tbdata && state.tbdata.qr_code !== payload)) {
      if (payload && payload !== '') {
        const table = state.tables.find(t => t.qr_code === payload)
        if (table) {
          Cookies.set(`${prefix}tb`, payload)
          commit(types.SET_TB, payload)
          commit(types.SET_TBDATA, table)
        } else {
          commit(types.SET_TB, '')
          commit(types.SET_TBDATA, null)
        }
      } else {
        commit(types.SET_TB, '')
        commit(types.SET_TBDATA, null)
      }
    }
  },

  setBrowserid ({ commit, state }) {
    if (!state.browserid) {
      const n = ('000' + Math.floor(Math.random() * 1000)).slice(-4)
      commit(types.SET_BROWSER_ID, n)
    }
  },

  setStoredVersion ({ commit }, payload) {
    // payload is version
    commit(types.SET_STOREDVERSION, payload)
  },

  async fetchLatestVersion ({ commit }) {
    try {
      const { data } = await axios.get('/api/version')
      commit(types.SET_VERSION, data)
    } catch (e) { }
  },

  async fetchTables ({ commit, state }) {
    try {
      const { data } = await axios.post('/api/restaurant/tables', {
        rid: state.rid
      })
      commit(types.FETCH_TABLES, data)
    } catch (e) { }
  },

  resetTables ({ commit }) {
    commit(types.RESET_TABLES)
  },

  resetLanguage ({ commit }) {
    commit(types.RESET_LANGUAGE)
  },

  changeLanguage ({ commit }, payload) {
    commit(types.CHANGE_LANGUAGE, payload)
  },

  setModeSelected ({ commit }) {
    commit(types.SET_MODE_SELECTED)
  },

  resetModeSelected ({ commit }) {
    commit(types.RESET_MODE_SELECTED)
  },

  setMemberToken ({ commit }, payload) {
    commit(types.SET_MEMBER_TOKEN, payload)
  },

  resetMemberToken ({ commit }) {
    commit(types.RESET_MEMBER_TOKEN)
  },

  setVisitAtTimestamp ({ commit }, payload) {
    commit(types.SET_VISIT_AT_TIMESTAMP, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js